import { Modal, Heading, Text, Input, Button, Link } from 'mondrian-react';
import styles from './styles.module.css';
import { useState } from 'react';
import { useLoader } from '../../../../hooks/loader';
import { useToast } from '../../../../hooks/toast';
import { Auth } from 'aws-amplify';

function ModalMdn(props) {
  const { open, close } = props;
  const { setLoading } = useLoader();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [new_password, setNew_password] = useState('');
  const [confirm_new_password, setConfirm_New_password] = useState('');
  const [inputCodeError, setInputCodeError] = useState(false);
  const [inputCodeErrorMessage, setInputCodeErrorMessage] = useState('');
  const [inputError, setInputError] = useState(false);
  const [inputErrorMessage, setInputErrorMessage] = useState('');
  const [resendedCode, setResendedCode] = useState(false);
  const { addToast } = useToast();

  const handleClose = () => {
    setStep(1);
    setEmail('');
    setCode('');
    setNew_password('');
    setConfirm_New_password('');
    setInputCodeError(false);
    setInputCodeErrorMessage('');
    setInputError(false);
    setInputErrorMessage('');
    setResendedCode(false);
    close();
  };

  const handleForgotPassword = async (event) => {
    event.preventDefault();

    setLoading(true);

    await Auth.forgotPassword(email)
      .then(() => {
        setLoading(false);
        setStep(2);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  async function lazyState() {
    return;
  }

  const handleForgotPasswordSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);
    await lazyState();
    setInputCodeError(false);
    setInputCodeErrorMessage('');
    setInputError(false);
    setInputErrorMessage('');

    if (new_password !== confirm_new_password) {
      setInputErrorMessage('As senhas precisam ser iguaís.');
      setLoading(false);
      return setInputError(true);
    }

    Auth.forgotPasswordSubmit(email, code, new_password)
      .then(() => {
        setLoading(false);
        return setStep(3);
      })
      .catch((err) => {
        console.log('err', JSON.stringify(err));

        if (
          err.code === 'CodeMismatchException' ||
          err.code === 'ExpiredCodeException'
        ) {
          setInputCodeErrorMessage('Código incorreto ou inválido.');
          setLoading(false);
          setInputCodeError(true);
        }

        if (
          err.code === 'InvalidPasswordException' ||
          err.code === 'InvalidParameterException'
        ) {
          setInputErrorMessage(
            'Mínimo 8 caracteres. Maiúscula e caracter especial.',
          );
          setLoading(false);
          setInputError(true);
        }

        if (err.code === 'LimitExceededException') {
          handleClose();
          setLoading(false);
          addToast({
            type: 'error',
            title: 'Limite de tentativas excedido!',
            description: 'Por favor, tente novamente mais tarde.',
          });
        }
      });
  };

  const handleResendSignUp = async () => {
    setCode('');

    setLoading(true);

    try {
      await Auth.resendSignUp(email);

      setLoading(false);

      setResendedCode(true);

      setInterval(() => {
        setResendedCode(false);
      }, 12000);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div>
      <Modal
        id="Modal-ForgotPassword"
        data={{
          header: <Heading md>Recuperar senha</Heading>,
          content: (
            <>
              {step === 1 && (
                <div>
                  <Text body className={styles.FormHeader}>
                    Digite abaixo o e-mail cadastrado.
                  </Text>
                  <form
                    autoComplete="new-password"
                    onSubmit={handleForgotPassword}
                  >
                    <div className={styles.FormInput}>
                      <Input
                        required
                        email
                        id="email-modal-forgot-password"
                        name="email-modal-forgot-password"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        autoComplete="new-password"
                      >
                        E-mail
                      </Input>
                    </div>

                    <Button
                      block
                      submit="true"
                      className={styles.FormButton}
                      disabled={!email && true}
                    >
                      Recuperar
                    </Button>
                  </form>
                </div>
              )}

              {step === 2 && (
                <div>
                  <Text body className={styles.FormHeader}>
                    Enviamos um código para seu email. <br />
                    Insira no campo abaixo.
                  </Text>
                  <form
                    onSubmit={handleForgotPasswordSubmit}
                    autoComplete="new-password"
                  >
                    <div className={styles.FormInput}>
                      <Input
                        required
                        text
                        name="code"
                        id="code"
                        autoComplete="new-password"
                        onChange={(e) => setCode(e.target.value)}
                        hasError={inputCodeError ? true : false}
                        errorMessage={
                          inputCodeErrorMessage ? inputCodeErrorMessage : ''
                        }
                        parentClassName={
                          inputCodeError && 'mdn-Input--attentionField'
                        }
                        value={code}
                      >
                        Código
                      </Input>
                    </div>
                    <div className={styles.FormInput}>
                      <Input
                        required
                        password
                        name="password"
                        id="password"
                        autoComplete="new-password"
                        onChange={(e) => setNew_password(e.target.value)}
                        hasError={inputError ? true : false}
                        errorMessage={
                          inputErrorMessage ? inputErrorMessage : ''
                        }
                        parentClassName={
                          inputError && 'mdn-Input--attentionField'
                        }
                        value={new_password}
                      >
                        Nova senha
                      </Input>
                    </div>
                    <div className={styles.FormInput}>
                      <Input
                        required
                        password
                        name="new-password"
                        id="new-password"
                        autoComplete="new-password"
                        onChange={(e) =>
                          setConfirm_New_password(e.target.value)
                        }
                        hasError={inputError ? true : false}
                        errorMessage={
                          inputErrorMessage ? inputErrorMessage : ''
                        }
                        parentClassName={
                          inputError && 'mdn-Input--attentionField'
                        }
                        value={confirm_new_password}
                      >
                        Confirme a nova senha
                      </Input>
                    </div>

                    <Button
                      block
                      submit="true"
                      className={styles.FormButton}
                      disabled={
                        code && new_password && confirm_new_password
                          ? false
                          : true
                      }
                    >
                      Enviar
                    </Button>

                    <div>
                      <Link
                        inverse="true"
                        className={styles.LinkResendCode}
                        onClick={handleResendSignUp}
                      >
                        Reenviar código
                      </Link>

                      {resendedCode && (
                        <span className={styles.ResendedCode}>
                          Código reenviado
                        </span>
                      )}
                    </div>
                  </form>
                </div>
              )}

              {step === 3 && (
                <div className={styles.Step3}>
                  <div className="mdn-Topic mdn-Topic--vertical mdn-Topic--icon">
                    <div className="mdn-Topic-symbol">
                      <i className="mdn-Icon-verificado mdn-Icon--md"></i>
                    </div>
                    <p className="mdn-Topic-description">
                      Sua senha foi <br /> alterada com sucesso!
                    </p>
                  </div>
                </div>
              )}
            </>
          ),
          isOpen: open,
          onCloseClick: handleClose,
        }}
      />
    </div>
  );
}

export default ModalMdn;
